import { useAppContext } from "../App";

interface StoryCardProps {
  id: number;
  title: string;
  username: string;
  likeCount: number;
  onClick: () => void;
}

function truncateTitle(title: string, maxLength: number = 60): string {
  if (title.length <= maxLength) return title;
  return title.slice(0, maxLength).trimEnd() + "…";
}

export function StoryCard({ id, title, username, likeCount, onClick }: StoryCardProps) {
  const { likes } = useAppContext();
  const hasLiked = likes.includes(id);
  const displayTitle = truncateTitle(title);

  return (
    <div className="story-card" onClick={onClick}>
      <div className="story-card-username">@{username}</div>
      <div className="story-card-title" title={title}>"{displayTitle}"</div>
      <div className="story-card-likes">
        <span className={`heart ${hasLiked ? "liked" : ""}`}>
          {hasLiked ? "♥" : "♡"}
        </span>
        <span>{likeCount}</span>
      </div>
    </div>
  );
}
